var pubkey = `-----BEGIN PGP PUBLIC KEY BLOCK-----
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=p8T/
-----END PGP PUBLIC KEY BLOCK-----
`;

var svc = {
    part1: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCrVWQLtVGs+hy6DZoZr5O9kRt3AQzI/F4dNs30VUQCQGU9W/Xr6mBsROJa6jwSVVYa1/EE9VaFrIUfkoUk4h9LKLKe',
    part2: null,

    set: function (str: any) {
        var self = this;
        self.part2 = str;
    },
    get: function () {
        return pubkey;
    }
};

export default svc;
